'use strict'

module.exports = {
  compare: require('./compare'),
  concat: require('./concat'),
  equals: require('./equals'),
  fromString: require('./from-string'),
  toString: require('./to-string')
}
